(function (Drupal) {
  Drupal.behaviors.bannerMain = { 
    attach: function (context, settings) {
      const deviceDetect = {
        breakpointMobile: 768,
        isMobile: () => {
          return window.matchMedia(`(max-width: ${deviceDetect.breakpointMobile}px)`).matches;
        },
      };

      const text_containers = document.querySelectorAll('.principal-banner .container-text', context);
      if (text_containers && !deviceDetect.isMobile()) {
        const areaSegura = 1246;
        const anchoVentana = window.innerWidth;
        
        const margen = (anchoVentana - areaSegura) / 2;
        text_containers.forEach((item, index) => {
          item.style.left = (margen + 60) + "px";
        });
      };
    }
  };
})(Drupal);
